<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Are you sure?</modal-header>
        </div>
        Request download approval on this creative?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Send"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_delete_creative',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String
  },
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.requestCreativeDownloadApproval({
        hash_id: this.confirmId
      }).then(() => {
        this.getCreativeUnits(this.creativeUnits.data.creative.hash_id).then(() => {
          this.finishLoading()
        })
        this.close()
      })
    }

  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-request-download-approval.vue